import { render, staticRenderFns } from "./detailsNav.vue?vue&type=template&id=9301a946&scoped=true"
import script from "./detailsNav.vue?vue&type=script&lang=js"
export * from "./detailsNav.vue?vue&type=script&lang=js"
import style0 from "./detailsNav.vue?vue&type=style&index=0&id=9301a946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9301a946",
  null
  
)

export default component.exports